import React from 'react';
import { inResults } from '../../../service';

export default function SwitchScreen({ value, field, children, ...props}) {
	const key = value ? value : field ? inResults(props.previousScreenResults, field) : 'default';
	return React.cloneElement(props[key] || props['default'] || React.Children.only(children), {...props});
}